import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface WsNotification {
  id: string;
  type: 'notification' | 'iot_alert';
  title: string;
  body: string;
  referenceId?: number;
  alertType?: string;
  deviceId?: string;
  timestamp: string;
  isRead: boolean;
}

export interface WsSliceState {
  notifications: WsNotification[];
  unreadCount: number;
}

const initialState: WsSliceState = {
  notifications: [],
  unreadCount: 0,
};

const wsSlice = createSlice({
  name: 'ws',
  initialState,
  reducers: {
    pushNotification(state, action: PayloadAction<WsNotification>) {
      const exists = state.notifications.some((n) => n.id === action.payload.id);
      if (!exists) {
        state.notifications.unshift(action.payload);
        if (state.notifications.length > 100) state.notifications.pop();
        state.unreadCount += 1;
      }
    },
    markAllRead(state) {
      state.notifications.forEach((n) => { n.isRead = true; });
      state.unreadCount = 0;
    },
    markRead(state, action: PayloadAction<string>) {
      const n = state.notifications.find((n) => n.id === action.payload);
      if (n && !n.isRead) {
        n.isRead = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    setUnreadCount(state, action: PayloadAction<number>) {
      state.unreadCount = action.payload;
    },
    incrementUnreadCount(state) {
      state.unreadCount += 1;
    },
  },
});

export const { pushNotification, markAllRead, markRead, setUnreadCount, incrementUnreadCount } =
  wsSlice.actions;
export const wsReducer = wsSlice.reducer;
export default wsSlice.reducer;
